import { Locale } from 'modules/i18n';

export const filterTagTranslation = {
  [Locale.en]: {
    ALL: 'All',
    BILLING: 'Billing',
    NEWS: 'News',
    SYSTEM: 'System',
    UNREAD: 'Unread',
    UNKNOWN: '',
  },
};
